@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    @switch (inputService.inputConfig.type) {
      @case (inputTypes.CHECKBOX) {
        <checkbox-input></checkbox-input>
      }
      @case (inputTypes.SELECT) {
        <select-input></select-input>
      }
      @case (inputTypes.TEXTAREA) {
        <textarea-input></textarea-input>
      }
      @case (inputTypes.RADIO) {
        <radio-input></radio-input>
      }
      @case (inputTypes.DATE) {
        <date-input></date-input>
      }
      @case (inputTypes.COMPARE_DATE) {
        <compare-date-input></compare-date-input>
      }
      @case (inputTypes.DATETIME) {
        <datetime-input></datetime-input>
      }
      @case (inputTypes.TOGGLE) {
        <toggle-input></toggle-input>
      }
      @case (inputTypes.READONLY) {
        <readonly-input></readonly-input>
      }
      @case (inputTypes.COLOR) {
        <color-input></color-input>
      }
      @case (inputTypes.DATASET_AUTOCOMPLETE) {
        <dataset-autocomplete-input></dataset-autocomplete-input>
      }
      @case (inputTypes.DATASET_COMBOBOX) {
        <dataset-combobox-input></dataset-combobox-input>
      }
      @case (inputTypes.DATASET_SELECT) {
        <dataset-select-input></dataset-select-input>
      }
      @case (inputTypes.DATASET_SELECT_DEP_DROPDOWN) {
        <dataset-select-dep-dropdown-input></dataset-select-dep-dropdown-input>
      }
      @case (inputTypes.DATASET_MULTISELECT) {
        <dataset-multiselect-input></dataset-multiselect-input>
      }
      @case (inputTypes.DATASET_SEARCH) {
        <dataset-search-input></dataset-search-input>
      }
      @case (inputTypes.TEXT_LIST) {
        <text-list-input></text-list-input>
      }
      @case (inputTypes.TEXT_LIST2) {
        <text-list-input2></text-list-input2>
      }
      @case (inputTypes.WEEK_HOURS) {
        <week-hours></week-hours>
      }
      @case (inputTypes.TINY_MCE) {
        <tinymce-input></tinymce-input>
      }
      @case (inputTypes.FILE) {
        <file-input></file-input>
      }
      @case (inputTypes.MULTIPLE_FILE) {
        <multiple-file-input></multiple-file-input>
      }
      @case (inputTypes.FILE_BLOCK) {
        <file-block-input
          [record]='formInputDefinition.inputConfig.fileBlockConfig.record'
          [inputService]='inputService'
          [documentFileKey]='inputService.formControlKey'
          [type]='"image"'
          [uploadRoute]='formInputDefinition.inputConfig.fileBlockConfig.uploadRoute'
          [uploadData]='formInputDefinition.inputConfig.fileBlockConfig.uploadData'
          [getUploadDataFun]='formInputDefinition.inputConfig.fileBlockConfig.getUploadDataFun'
          [imageOptions]='formInputDefinition.inputConfig.fileBlockConfig.imageOptions'
          [svgEnablded]='true'
          [uploadLabel]='"Carica Immagine" | translate'
          (changed)='formInputDefinition.inputConfig.fileBlockConfig.changed($event)'
        ></file-block-input>
      }
      @case (inputTypes.TIME) {
        <time-input></time-input>
      }
      @case (inputTypes.TEXT) {
        <text-input></text-input>
      }
      @case (inputTypes.HIDDEN) {
        <input-hidden></input-hidden>
      }
      @case (inputTypes.NUMBER) {
        <number-input></number-input>
      }
      @case (inputTypes.MULTI_SELECT) {
        <multiselect-input></multiselect-input>
      }
      @case (inputTypes.PASSWORD) {
        <password-input></password-input>
      }
      @case (inputTypes.SELECT_CUSTOM_ICON) {
        <select-custom-icon-input></select-custom-icon-input>
      }
      @case (inputTypes.SELECT_FILTERABLE) {
        <select-filterable-input></select-filterable-input>
      }
      @case (inputTypes.BASE_TEXT) {
        <base-text-input></base-text-input>
      }
      @case (inputTypes.COUNTER) {
        <counter-input></counter-input>
      }
      @case (inputTypes.ASSISTANT_AREAS) {
        <assistant-areas-input></assistant-areas-input>
      }
      @default {
        <text-input></text-input>
      }
    }
  </ng-container>
}